import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DispatchDeviceComponent } from './dispatch-device.component';

const routes: Routes = [
  {
    path: 'dispatch-device',
    data: { name: 'Add Dispatch Devices', isTab: false },
    component: DispatchDeviceComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DispatchDevicePageRoutingModule {}
